import { IItem } from "../../../../domain/document/items";

export interface IItemPastableObject {
  isItemPastable(source: IItem): boolean;
  pasteItem(source: IItem): void;
}

export function instanceOfIItemPastableObject(instance: any): instance is IItemPastableObject {
  return instance
      && (instance.isItemPastable !== undefined)
      && (instance.pasteItem !== undefined);
}
